import React from 'react';
import WebMasterLink from './buttons/WebMasterLink';

export default function Header(props) {
    return (
        <header
            style={{
                transition: '0.4s', height: props.menu === '' ? '16vh' : '8vh',
                }}
            className="App-header noselect">
            <span
                className="logo"
                style={{position: 'absolute', left: '2vw'}}
                onClick={() => props.setMenu('')}>
                <img src={process.env.PUBLIC_URL + '/icons/logo_clown.png'} width="70" height="70" alt="logo"/>
            </span>
            <h1 style={{marginTop: '25px'}}>The artist's website</h1>
            <WebMasterLink />
        </header>
    )
}
